<template>
  <v-app-bar id="app-bar" absolute app color="transparent" flat height="75">
    <v-btn class="mr-3" elevation="1" fab small @click="$router.go(-1)">
      <v-icon>mdi-arrow-left-thick</v-icon>
    </v-btn>
    <v-btn class="mr-3" elevation="1" fab small @click="setDrawer(!drawer)">
      <v-icon v-if="value">mdi-view-quilt</v-icon>

      <v-icon v-else>mdi-dots-vertical</v-icon>
    </v-btn>

    <v-toolbar-title
      class="hidden-xs-and-down font-weight-medium"
      v-text="$i18n.t($route.name)"
    />
    <v-spacer />

    <div class="mx-3" />

    <!-- <v-btn class="ml-2" min-width="0" text to="/">
      <v-icon>mdi-view-dashboard</v-icon>
    </v-btn>-->

    <v-btn
      class="ml-2"
      min-width="0"
      text
      @click="showVehicleExpenseReport = true"
      v-if="authContext && authContext.corpType != 1"
    >
      <v-icon color="primary">mdi-truck-fast</v-icon>
    </v-btn>

    <!-- <v-btn
      class="ml-2"
      min-width="0"
      text
      @click="showLoadBoard = true"
      v-if="authContext && authContext.corpType != 1"
    >
      <v-icon color="primary">mdi-domain</v-icon>
    </v-btn> -->

    <z-load-board
      :showDialog="showLoadBoard"
      :corpType="authContext.corpType"
      @close="closeLoadBoard"
    ></z-load-board>

    <v-btn
      class="ml-2"
      min-width="0"
      text
      @click="showBirdEye = true"
      v-if="authContext && authContext.corpType != 1"
    >
      <v-icon color="primary">mdi-map-search</v-icon>
    </v-btn>

    <bar-menu
      v-if="tripCount"
      :count="tripCount"
      :type="'-trip'"
      :icon="'mdi-map-marker-path'"
    />

    <!-- <bar-menu v-if="vehicleCount" :count="vehicleCount" :type="'-car'" :icon="'mdi-truck-fast'" /> -->
    <!-- <bar-menu :count="incidentCount" :type="'-incident'" :icon="'mdi-tow-truck'" /> -->

    <!-- Lang Menu -->
    <v-menu
      bottom
      left
      offset-y
      origin="top right"
      transition="scale-transition"
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn
          class="ml-2"
          min-width="0"
          text
          v-bind="attrs"
          v-on="on"
          style="padding: 0px !important"
        >
          <v-img :src="lang.pic" style="height: 24px; width: 30px"></v-img>
        </v-btn>
      </template>

      <v-list :tile="false" nav>
        <div v-for="l in languages" :key="l._id" @click="setLang(l)">
          <app-bar-item ripple dense class="lang-item">
            <v-icon v-if="l.code == lang.code" class="checked"
              >mdi-check</v-icon
            >
            <div v-if="l.code != lang.code" class="spacer"></div>
            <v-img :src="l.pic" class="flag"></v-img>
            <v-list-item-title v-text="l.label" />
          </app-bar-item>
        </div>
      </v-list>
    </v-menu>

    <v-menu
      bottom
      left
      offset-y
      origin="top right"
      transition="scale-transition"
      v-if="false"
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn class="ml-2" min-width="0" text v-bind="attrs" v-on="on">
          <v-badge color="red" overlap bordered>
            <template v-slot:badge>
              <span>5</span>
            </template>

            <v-icon>mdi-bell</v-icon>
          </v-badge>
        </v-btn>
      </template>

      <v-card style="margin: 0">
        <v-list>
          <v-list-item>
            <v-list-item-avatar>
              <img src="https://cdn.vuetifyjs.com/images/john.jpg" alt="John" />
            </v-list-item-avatar>

            <v-list-item-content>
              <v-list-item-title>John Leider</v-list-item-title>
              <v-list-item-subtitle>Founder of Vuetify.js</v-list-item-subtitle>
            </v-list-item-content>

            <v-list-item-action>
              <v-btn :class="fav ? 'red--text' : ''" icon @click="fav = !fav">
                <v-icon>mdi-heart</v-icon>
              </v-btn>
            </v-list-item-action>
          </v-list-item>
        </v-list>

        <v-divider></v-divider>

        <v-list style="max-height: 200px; overflow-y: auto">
          <v-list-item>
            <v-list-item-action>
              <v-switch color="purple"></v-switch>
            </v-list-item-action>
            <v-list-item-title>Enable messages</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-action>
              <v-switch color="purple"></v-switch>
            </v-list-item-action>
            <v-list-item-title>Enable hints</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-action>
              <v-switch color="purple"></v-switch>
            </v-list-item-action>
            <v-list-item-title>Enable messages</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-action>
              <v-switch color="purple"></v-switch>
            </v-list-item-action>
            <v-list-item-title>Enable hints</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-action>
              <v-switch color="purple"></v-switch>
            </v-list-item-action>
            <v-list-item-title>Enable messages</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-action>
              <v-switch color="purple"></v-switch>
            </v-list-item-action>
            <v-list-item-title>Enable hints</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-action>
              <v-switch color="purple"></v-switch>
            </v-list-item-action>
            <v-list-item-title>Enable messages</v-list-item-title>
          </v-list-item>

          <v-list-item>
            <v-list-item-action>
              <v-switch color="purple"></v-switch>
            </v-list-item-action>
            <v-list-item-title>Enable hints</v-list-item-title>
          </v-list-item>
        </v-list>
        <v-divider></v-divider>
        <v-card-actions>
          <v-spacer></v-spacer>

          <v-btn text @click="menu = false">Cancel</v-btn>
          <v-btn color="primary" text @click="menu = false">Save</v-btn>
        </v-card-actions>
      </v-card>
    </v-menu>

    <v-menu
      bottom
      left
      offset-y
      origin="top right"
      transition="scale-transition"
      open-on-hover
    >
      <template v-slot:activator="{ attrs, on }">
        <v-btn class="ml-2" min-width="0" text v-bind="attrs" v-on="on">
          <v-icon>mdi-account</v-icon>
        </v-btn>
      </template>

      <v-list :tile="false" nav>
        <div>
          <app-bar-item>
            <v-list-item-title @click="profile">
              <v-icon>mdi-account</v-icon>
              {{ $i18n.t("My Profile") }}
            </v-list-item-title>
          </app-bar-item>
          <app-bar-item>
            <v-list-item-title @click="account">
              <v-icon>mdi-shield-account</v-icon>
              {{ $i18n.t("My Account") }}
            </v-list-item-title>
          </app-bar-item>
          <app-bar-item>
            <v-list-item-title @click="ticket">
              <v-icon>mdi-ticket</v-icon>
              {{ $i18n.t("Support Tickets") }}
            </v-list-item-title>
          </app-bar-item>
          <app-bar-item>
            <v-list-item-title @click="help">
              <v-icon>mdi-help-rhombus</v-icon>
              {{ $i18n.t("User Guide") }}
            </v-list-item-title>
          </app-bar-item>
          <app-bar-item>
            <v-list-item-title @click="logout">
              <v-icon>mdi-logout</v-icon>
              {{ $i18n.t("Logout") }}
            </v-list-item-title>
          </app-bar-item>
        </div>
      </v-list>
    </v-menu>
    <v-dialog v-model="showBirdEye" style="background-color: white">
      <v-row style="background-color: white" class="mx-0">
        <v-col cols="12" md="6">
          <h3 class="mx-5 my-5" style="color: #607d8b">
            {{ $i18n.t("Bird Eye View") }}
          </h3>
        </v-col>
        <v-col cols="12" md="6">
          <v-btn text fab @click="showBirdEye = false" style="float: right">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row>
      <v-row style="background-color: white" class="mx-0">
        <v-col cols="12" md="12" class="px-0">
          <bird-eye />
        </v-col>
      </v-row>
    </v-dialog>

    <v-dialog v-model="showVehicleExpenseReport" style="background-color: white">
      <!-- <v-row style="background-color: white" class="mx-0">
        <v-col cols="12" md="6">
          <h3 class="mx-5 my-5" style="color: #607d8b">
            {{ $i18n.t("Vehicle Alerts") }}
          </h3>
        </v-col>
        <v-col cols="12" md="6">
          <v-btn text fab @click="showVehicleExpenseReport = false" style="float: right">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-col>
      </v-row> -->
      <v-toolbar color="white" fixed>
          <h3>{{ $i18n.t("Vehicle Alerts") }}</h3>
          <v-spacer></v-spacer>
          <v-btn icon @click="showVehicleExpenseReport = false">
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-toolbar>
      <v-row style="background-color: white" class="mx-0">
        <v-col cols="12" md="12" class="px-0">
          <vehicle-expense-stats/>
        </v-col>
      </v-row>
    </v-dialog>

  </v-app-bar>
</template>

<script>
import { VHover, VListItem } from "vuetify/lib";
import { Vue, Component } from "vue-property-decorator";
import { doGet } from "@/store/common/module/apis";
import common from "@/store/common/module/common";
import { mapState, mapMutations } from "vuex";
import auth from "@/store/user/module/auth";
import birdEye from "@/views/birdeye/BirdEye.vue";
import BarMenu from "@/components/layout/BarMenu.vue";
import VehicleExpenseStats from "@/views/dashboard/VehicleExpenseStats.vue";

@Component({
  components: {
    AppBarItem: {
      render(h) {
        return h(VHover, {
          scopedSlots: {
            default: ({ hover }) => {
              return h(
                VListItem,
                {
                  attrs: this.$attrs,
                  class: {
                    "black--text": !hover,
                    "white--text secondary elevation-12": hover,
                  },
                  props: {
                    activeClass: "",
                    dark: hover,
                    link: true,
                    ...this.$attrs,
                  },
                },
                this.$slots.default
              );
            },
          },
        });
      },
    },
    birdEye,
    BarMenu,
    VehicleExpenseStats,
  },
  props: {
    value: {
      type: Boolean,
      default: false,
    },
  },
  computed: {
    ...mapState(["drawer"]),
    lang() {
      return common.language;
    },
    languages() {
      return common.languages;
    },
  },
  methods: {
    ...mapMutations({
      setDrawer: "SET_DRAWER",
    }),
  },
})
export default class DashboardCoreAppBar extends Vue {
  tripNotif = [];
  vehicleNotif = [];
  incidentNotif = [];
  fav = true;
  alertsFetched = {};
  incidentCount = null;
  vehicleCount = null;
  tripCount = null;
  showBirdEye = false;
  showLoadBoard = false;
  showVehicleExpenseReport = false;
  authContext = {};

  async populateCounts() {
    try {
      const response = await doGet("/api/dashboard/counts");
      if (response) {
        if (response.INCIDENT) {
          this.incidentCount = parseInt(response.INCIDENT);
        }
        if (response.VEHICLE) {
          this.vehicleCount = parseInt(response.VEHICLE);
        }
        if (response.TRIP) {
          this.tripCount = parseInt(response.TRIP);
        }
      }
    } catch (e) {
      console.log(e);
    }
  }

  closeLoadBoard() {
    this.showLoadBoard = false;
  }

  closeVehicleExpenseReport() {
    this.showVehicleExpenseReport = false;
  }

  async mounted() {
    await auth.doPostLogin();
    await common.populateLanguages();
    this.populateCounts();
    this.authContext = auth.authContent;
  }

  logout() {
    auth.logout();
  }

  profile() {
    this.$router.push("/profile");
  }

  account() {
    this.$router.push("/myaccount");
  }

  ticket() {
    this.$router.push("/ticket");
  }

  help() {
    this.$router.push("/help");
  }

  async setLang(language) {
    await common.setLang(language);
  }
}
</script>

<style scoped>
.lang-item {
  min-width: 200px;
  align-items: flex-start;
  padding: 10px 20px;
}

.lang-item .spacer {
  float: left;
  width: 30px;
  height: 20px;
}

.lang-item .flag {
  height: 24px;
  width: 30px;
  margin-right: 10px;
  float: left;
}

.lang-item .checked {
  float: left;
  left: -10px;
}
</style>
